import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';
import { BlockImage } from 'libs/editor/styles';

@observer
class ImageBlockNode extends React.Component {
  render() {
    const { node, isSelected, attributes, readOnly } = this.props;
    const src = node.data.get('src');
    return (
      <BlockImage selected={isSelected && !readOnly} {...attributes}>
        <img src={src} />
      </BlockImage>
    );
  }
}

ImageBlockNode.propTypes = {
  node: PropTypes.object,
  isSelected: PropTypes.bool,
  attributes: PropTypes.object,
  readOnly: PropTypes.bool,
};

export function ImageBlock() {
  return {
    button: {
      elementType: 'block',
      type: 'image-block',
      icon: 'photo',
    },
    plugins: [
      RenderNode('image-block', props => <ImageBlockNode {...props} />),
    ],
  };
}
